import AutomaticElementReloader from '../automatic-element-reloader';

const RELOAD_ATTACHMENT_INTERVAL = 10000;

export default class AttachmentReloader extends AutomaticElementReloader {
  constructor(element) {
    super(element, {intervalDelay: RELOAD_ATTACHMENT_INTERVAL});
  }

  handleAJAXsuccess(data) {
    super.handleAJAXsuccess(...arguments);

    const object = $('<div />').html(data);

    if (
      !object
        .children()
        .first()
        .hasClass('groupMessage-attachment--unextracted')
    ) {
      this.unbindEvents();

      this.$element.html(object.find('.groupMessage-attachment').html());
    }
  }

  handleAJAXfailure() {
    super.handleAJAXfailure(...arguments);

    this.unbindEvents();
  }
}
